import React from "react";
import img2 from "../../../../../../assets/images/AISummit/aicopilot3.jpg";
import CustomButton from "../../../../../../shared_components/CustomButton";
import { FaStar } from "react-icons/fa6";
const TestimonialSection = () => {
    const stars = [
        <FaStar />, <FaStar />, <FaStar />, <FaStar />, <FaStar />
    ]
    return (
        <section className="row mx-0 align-items-center justify-content-center my-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 d-flex align-items-center justify-content-center">
                    <div className="col-12 col-md-6">
                        <img
                            src={img2}
                            alt="Community Event"
                            className="img-fluid"
                        />
                    </div>
                    <div className="row mx-0 d-flex align-items-start justify-content-center"></div>
                    <div className="col-12 col-md-6">
                        <i className="col-md-6">{stars}</i>
                        <p className="col-md-10 mt-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.</p>
                        <div className="row mx-0 d-flex align-items-start justify-content-center">
                            <div className="col-md-6 border-right border-dark testimonial-border">
                                <h6 className="fs-16 fw-bold text-start">Sarah Chen</h6>
                                <p>Student organizer, Stanford</p>
                            </div>
                            <div className="col-md-6"> Webflow
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialSection;
